import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  body {
    --small: 18px;
  --medium: calc(var(--small) * 1.618);
  --large: calc(var(--medium) * 1.618);
  font-size: var(--small);
  line-height: 1.4;
  letter-spacing: 0.5px;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Poppins" ,sans-serif;
    background-color: #333;
    color: white;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }
  h1{
    margin-bottom: var(--large);
    font-size: var(--large);
  }
  h2{
    margin-bottom: 2.5rem;
    color: #e4e4e4;
  }

  a {
    text-decoration: none;
    color: inherit;
    font-size: var(--small);
    font-weight: 300;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`;

export default GlobalStyles;
